<section class="flex flex-col bg-white rounded-lg w-96">
    <article class="flex items-center justify-between bg-primary-purple-light-2 rounded-ss-lg rounded-se-lg p-2 px-4">
        <div class="flex items-center gap-6">
            @if (totalPrice != null) {
                <div class="flex items-center gap-2">
                    <img [src]="images.booking.fare" alt="fare" class="h-6 w-6" />
                    <label class="font-normal text-base">{{ totalPrice }}€</label>
                </div>
            }
            <div class="flex items-center gap-2">
                <img [src]="images.booking.ticket.ticket" alt="ticket" class="h-6 w-6" />
                <label class="font-normal text-base">{{ pax }}</label>
            </div>
        </div>
        <img [src]="images.close" alt="close" class="h-5 w-5 cursor-pointer" (click)="closeDetail.emit()" />
    </article>
    <article class="flex flex-col p-4">
        @let firstLeg = trip[0];
        @let lastLeg = trip[trip.length - 1];
        @if (firstLeg.walkingPickup; as walkingPickup) {
            <div class="flex gap-3">
                <div class="flex flex-col items-center w-6">
                    <img [src]="images.origin" alt="origin" class="h-6 w-6" />
                </div>
                <div class="flex-1 flex justify-between gap-2">
                    <label class="font-semibold text-base">{{ walkingPickup.name }}</label>
                    <span class="font-semibold text-base whitespace-nowrap">{{ bookingsService.availabilityDepartureTime(firstLeg) }}</span>
                </div>
            </div>
            <div class="flex gap-3 mb-2">
                <div class="flex flex-col items-center w-6">
                    <div class="dotted flex-1"></div>
                </div>
                <div class="flex-1 flex items-center gap-2">
                    <img [src]="images.booking.pedestrian" alt="pedestrian" class="h-4 w-4" />
                    <label class="font-normal text-base">{{ bookingsService.walkingText(walkingPickup) }}</label>
                </div>
            </div>
        } @else if (hasAlternativeInitialWalk(firstLeg)) {
            <div class="flex gap-3">
                <div class="flex flex-col items-center w-6">
                    <img [src]="images.origin" alt="origin" class="h-6 w-6" />
                </div>
                <div class="flex-1 flex justify-between gap-2">
                    <label class="font-semibold text-base">{{ newBooking.originStop?.name }} ({{ literalService.get('bookings.notAvailable', true) }})</label>
                </div>
            </div>
            <div class="flex gap-3 mb-2">
                <div class="flex flex-col items-center w-6">
                    <div class="dotted flex-1"></div>
                </div>
                <div class="flex-1 flex items-center gap-2">
                    <img [src]="images.booking.pedestrian" alt="pedestrian" class="h-4 w-4" />
                    <label class="font-normal text-base">{{ literalService.get('bookings.walk', true) }}</label>
                </div>
            </div>
        }
        @for (leg of trip; track leg.id) {
            @let alternativeOrigin = isAlternativeOrigin(leg);
            @let alternativeDestination = isAlternativeDestination(leg);
            <div class="flex gap-3">
                <div class="flex flex-col items-center w-6">
                    <div class="flex h-5 w-5 shrink-0 rounded-[50%] justify-center items-center bg-primary-purple-light" [class.mt-3]="alternativeOrigin">
                        <div class="h-2.5 w-2.5 rounded-[50%] bg-white"></div>
                    </div>
                    <div class="gradient w-1 flex-1"></div>
                </div>
                <div class="flex-1 flex flex-col gap-3 pb-5">
                    <div class="flex justify-between gap-2" [class.items-center]="alternativeOrigin">
                        <label class="text-base" [class.font-bold]="!!leg.walkingPickup" [class.font-semibold]="!leg.walkingPickup" [class.alternative-stop]="alternativeOrigin">
                            {{ leg.inStop.name }}
                            @if (alternativeOrigin) {
                                <span class="primary-purple-light-text font-normal ml-1">{{ literalService.get('bookings.alternative.tag', true) }}</span>
                            }
                        </label>
                        <span class="font-bold text-xl whitespace-nowrap">{{ moment(leg.inStop.dateTime).format('HH:mm') }}</span>
                    </div>
                    <div class="flex items-center gap-3">
                        <div class="flex items-center gap-2 shrink-0">
                            <img [src]="images.busPrivate" alt="bus private" class="h-5 w-5" />
                            <app-service-tag [serviceInfo]="leg.serviceInfo"></app-service-tag>
                            @if (trip.length === 1 && !leg.walkingPickup && !leg.walkingDropoff) {
                                <label class="font-semibold text-base">{{ leg.serviceInfo.name }}</label>
                            }
                        </div>
                        @if (leg.vehiclePlate || leg.driverName) {
                            <div class="flex flex-col gap-1 min-w-0">
                                @if (leg.vehiclePlate) {
                                    <div class="flex items-center gap-1">
                                        <img [src]="images.busCar" alt="vehicle" class="h-5 w-5 shrink-0" />
                                        <label class="font-normal text-sm truncate">{{ leg.vehiclePlate }}</label>
                                    </div>
                                }
                                @if (leg.driverName) {
                                    <div class="flex items-center gap-1">
                                        <img [src]="images.booking.driver" alt="driver" class="h-5 w-5 shrink-0" />
                                        <label class="font-normal text-sm truncate">{{ leg.driverName }}</label>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    @if (leg.price != null) {
                        <div class="flex items-center gap-2">
                            <label class="font-normal text-base">{{ leg.price }}€</label>
                            <img [src]="images.booking.ticket.ticket" alt="ticket" class="h-5 w-5" />
                            <label class="font-normal text-base">{{ pax }}</label>
                        </div>
                    }
                </div>
            </div>
            <div class="flex gap-3">
                <div class="flex flex-col items-center w-6">
                    @if (alternativeDestination) {
                        <div class="bg-primary-green w-1 flex-1"></div>
                    }
                    <div class="flex h-5 w-5 shrink-0 rounded-[50%] justify-center items-center bg-primary-green">
                        <div class="h-2.5 w-2.5 rounded-[50%] bg-white"></div>
                    </div>
                    @if (alternativeDestination) {
                        <div class="walking-dot w-6 flex-1"></div>
                    }
                </div>
                <div class="flex-1 flex justify-between gap-2" [class.items-center]="alternativeDestination">
                    <label class="text-base" [class.font-bold]="!!leg.walkingDropoff" [class.font-semibold]="!leg.walkingDropoff" [class.alternative-stop]="alternativeDestination">
                        {{ leg.outStop.name }}
                        @if (alternativeDestination) {
                            <span class="primary-purple-light-text font-normal ml-1">{{ literalService.get('bookings.alternative.tag', true) }}</span>
                        }
                    </label>
                    <span class="font-bold text-xl whitespace-nowrap">{{ moment(leg.outStop.dateTime).format('HH:mm') }}</span>
                </div>
            </div>
        }
        @if (lastLeg.walkingDropoff; as walkingDropoff) {
            <div class="flex gap-3 mb-2">
                <div class="flex flex-col items-center w-6">
                    <div class="dotted flex-1"></div>
                </div>
                <div class="flex-1 flex items-center gap-2">
                    <img [src]="images.booking.pedestrian" alt="pedestrian" class="h-4 w-4" />
                    <label class="font-normal text-base">{{ bookingsService.walkingText(walkingDropoff) }}</label>
                </div>
            </div>
            <div class="flex gap-3">
                <div class="flex flex-col items-center w-6">
                    <img [src]="images.destination" alt="destination" class="h-6 w-6" />
                </div>
                <div class="flex-1 flex justify-between gap-2">
                    <label class="font-semibold text-base">{{ walkingDropoff.name }}</label>
                    <span class="font-semibold text-base whitespace-nowrap">{{ bookingsService.availabilityArrivalTime(lastLeg) }}</span>
                </div>
            </div>
        } @else if (hasAlternativeFinalWalk(lastLeg)) {
            <div class="flex gap-3 mb-2">
                <div class="flex flex-col items-center w-6">
                    <div class="dotted flex-1"></div>
                </div>
                <div class="flex-1 flex items-center gap-2">
                    <img [src]="images.booking.pedestrian" alt="pedestrian" class="h-4 w-4" />
                    <label class="font-normal text-base">{{ literalService.get('bookings.walk', true) }}</label>
                </div>
            </div>
            <div class="flex gap-3">
                <div class="flex flex-col items-center w-6">
                    <img [src]="images.destination" alt="destination" class="h-6 w-6" />
                </div>
                <div class="flex-1 flex justify-between gap-2">
                    <label class="font-semibold text-base">{{ newBooking.destinationStop?.name }} ({{ literalService.get('bookings.notAvailable', true) }})</label>
                </div>
            </div>
        }
    </article>
</section>
